import { render } from "./SinglePrice.vue?vue&type=template&id=143d3643&scoped=true"
import script from "./SinglePrice.vue?vue&type=script&lang=js"
export * from "./SinglePrice.vue?vue&type=script&lang=js"

import "./SinglePrice.vue?vue&type=style&index=0&id=143d3643&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143d3643"]])

export default __exports__